(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxAudienceInfo', {
		bindings: {
			value: '=?',
			value2: '=?',
			value3: '=?',
			value4: '=?',
		},
		controller: MxAudienceInfoCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-audience-info/mx-audience-info.html',
	});

	MxAudienceInfoCtrl.$inject = ['mx.SolutionBuilderAgent.Http', 'mx.internationalization'];

	function MxAudienceInfoCtrl(http, i18n) {
		var vm = this;
		vm.showAudience = false;
		vm.showDetails = true;

		vm.$onInit = function () {
			vm.i18n = i18n.get('solutionBuilderAgent.components.mx-audience-info');
			vm.i18n.nobody = vm.i18n.nobody || i18n.get('solutionBuilderAgent.components.mx-audience-info.nobody');
			vm.title = vm.i18n.showAudience;
		};

		vm.toggleAudience = function () {
			vm.showAudience = !vm.showAudience;
			vm.title = !vm.showAudience ? vm.i18n.showAudience : vm.i18n.hideAudience;
			if (vm.data === undefined) {
				http.get('api/Audience/' + vm.value).then(function (result) {
					vm.data = result.Data;
					vm.value2 = result.Data.length === 0;
					vm.value3 = result.Unrestricted;
					vm.value4 = result.StrictAdminControl;
					initData(vm.data);
				});
			}
		};

		function initData(data) {
			var location = {
				Id: '4',
				DisplayString: '4',
				Name: vm.i18n.locations,
			};

			var orgUnit = {
				Id: '3',
				DisplayString: '3',
				Name: vm.i18n['org-units'],
			};

			var user = {
				Id: '2',
				DisplayString: '2',
				Name: vm.i18n.users,
			};

			var role = {
				Id: '1',
				DisplayString: '1',
				Name: vm.i18n.roles,
			};
			var types = [location, orgUnit, user, role];
			vm.dataByType = [];

			data.forEach(function (obj) {
				switch (obj.EntityType) {
					case 'SPSSecurityTypeRole':
						vm.dataByType.push(angular.extend({}, obj, { Parent: '1' }));
						role.show = 1;
						break;

					case 'SPSUserType':
						vm.dataByType.push(angular.extend({}, obj, { Parent: '2' }));
						user.show = 1;
						break;

					case 'SPSOrgUnitType':
						vm.dataByType.push(angular.extend({}, obj, { Parent: '3' }));
						orgUnit.show = 1;
						break;

					case 'SPSLocationType':
						vm.dataByType.push(angular.extend({}, obj, { Parent: '4' }));
						location.show = 1;
						break;
				}
			});

			types.forEach(function (t) {
				if (t.show) {
					vm.dataByType.push(t);
				}
			});
		}

		vm.toggleDetails = function () {
			vm.showDetails = !vm.showDetails;
		};

		return vm;
	}
})();
